/*
 * © 2023 Vertafore, Inc. All rights reserved.
 * Reproduction and distribution without the written permission of Vertafore is prohibited.
 */
import { RatingArtifactV1 } from "../../../types/customTypes/ratModels";

export enum ActionTypesEnum {
  GET_ARTIFACTS_BY_CID = "GET_ARTIFACTS_BY_CID",
}

export interface RatingArtifactState {
  ratingArtifacts: { [correlationId: string]: RatingArtifact[] };
}

export interface GetRatingArtifactsForCIDAction {
  type: typeof ActionTypesEnum.GET_ARTIFACTS_BY_CID;
  payload: { correlationId: string; ratingArtifacts: RatingArtifact[] };
}

export type RatingArtifactsActionTypes = GetRatingArtifactsForCIDAction;
export type RatingArtifact = RatingArtifactV1;
